"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "create-game",
    class: "create-game"
};
const _hoisted_2 = { class: "changelog" };
const _hoisted_3 = ["href"];
const _hoisted_4 = {
    key: 0,
    class: "discord-invite"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "create-game-form create-game-panel create-game--block" };
const _hoisted_7 = { class: "create-game-options" };
const _hoisted_8 = { class: "create-game-page-container" };
const _hoisted_9 = { class: "create-game-page-column" };
const _hoisted_10 = ["value", "id"];
const _hoisted_11 = ["for"];
const _hoisted_12 = { class: "create-game-page-column" };
const _hoisted_13 = { for: "allOfficialExpansions-checkbox" };
const _hoisted_14 = {
    for: "corporateEra-checkbox",
    class: "expansion-button"
};
const _hoisted_15 = {
    for: "prelude-checkbox",
    class: "expansion-button"
};
const _hoisted_16 = {
    for: "prelude2-checkbox",
    class: "expansion-button"
};
const _hoisted_17 = {
    for: "venusNext-checkbox",
    class: "expansion-button"
};
const _hoisted_18 = {
    for: "colonies-checkbox",
    class: "expansion-button"
};
const _hoisted_19 = {
    for: "turmoil-checkbox",
    class: "expansion-button"
};
const _hoisted_20 = {
    for: "promo-checkbox",
    class: "expansion-button"
};
const _hoisted_21 = ["href"];
const _hoisted_22 = { class: "create-game-subsection-label" };
const _hoisted_23 = {
    for: "ares-checkbox",
    class: "expansion-button"
};
const _hoisted_24 = ["href"];
const _hoisted_25 = { for: "aresExtremeVariantVariant-checkbox" };
const _hoisted_26 = ["href"];
const _hoisted_27 = {
    for: "communityCards-checkbox",
    class: "expansion-button"
};
const _hoisted_28 = ["href"];
const _hoisted_29 = {
    for: "themoon-checkbox",
    class: "expansion-button"
};
const _hoisted_30 = ["href"];
const _hoisted_31 = { for: "requiresMoonTrackCompletion-checkbox" };
const _hoisted_32 = { for: "moonStandardProjectVariant2-checkbox" };
const _hoisted_33 = ["href"];
const _hoisted_34 = { for: "moonStandardProjectVariant1-checkbox" };
const _hoisted_35 = ["href"];
const _hoisted_36 = {
    for: "politicalAgendas-checkbox",
    class: "expansion-button"
};
const _hoisted_37 = {
    href: "https://www.notion.so/Political-Agendas-8c6b0b018a884692be29b3ef44b340a9",
    class: "tooltip",
    "data-tooltip": "Link opens in a new tab/window",
    target: "_blank"
};
const _hoisted_38 = {
    key: 0,
    class: "create-game-page-column-row"
};
const _hoisted_39 = ["value"];
const _hoisted_40 = {
    class: "label-agendaStyle agendaStyle-random",
    for: "randomAgendaStyle-radio"
};
const _hoisted_41 = { class: "agendas-text" };
const _hoisted_42 = ["value"];
const _hoisted_43 = {
    class: "label-agendaStyle agendaStyle-chairman",
    for: "chairmanAgendaStyle-radio"
};
const _hoisted_44 = { class: "agendas-text" };
const _hoisted_45 = {
    for: "pathfinders-checkbox",
    class: "expansion-button"
};
const _hoisted_46 = ["href"];
const _hoisted_47 = { for: "altVenusBoard-checkbox" };
const _hoisted_48 = ["href"];
const _hoisted_49 = {
    for: "ceo-checkbox",
    class: "expansion-button"
};
const _hoisted_50 = ["href"];
const _hoisted_51 = {
    for: "starwars-checkbox",
    class: "expansion-button"
};
const _hoisted_52 = ["href"];
const _hoisted_53 = {
    for: "underworld-checkbox",
    class: "expansion-button"
};
const _hoisted_54 = ["href"];
const _hoisted_55 = { class: "create-game-page-column" };
const _hoisted_56 = {
    key: 0,
    class: "create-game-subsection-label"
};
const _hoisted_57 = ["value", "id"];
const _hoisted_58 = ["for"];
const _hoisted_59 = { class: "capitalized" };
const _hoisted_60 = ["href"];
const _hoisted_61 = { class: "create-game-page-column" };
const _hoisted_62 = { for: "startingCorpNum-checkbox" };
const _hoisted_63 = {
    key: 0,
    for: "startingPreludeENum-checkbox"
};
const _hoisted_64 = {
    key: 1,
    for: "startingCEONum-checkbox"
};
const _hoisted_65 = { for: "WGT-checkbox" };
const _hoisted_66 = ["href"];
const _hoisted_67 = { for: "soloTR-checkbox" };
const _hoisted_68 = ["href"];
const _hoisted_69 = { for: "undo-checkbox" };
const _hoisted_70 = ["href"];
const _hoisted_71 = { key: 3 };
const _hoisted_72 = { for: "timer-checkbox" };
const _hoisted_73 = { for: "escapevelocity-checkbox" };
const _hoisted_74 = ["href"];
const _hoisted_75 = { for: "escapeThreshold-checkbox" };
const _hoisted_76 = { for: "escapeBonusSeconds-checkbox" };
const _hoisted_77 = { for: "escapePeriod-checkbox" };
const _hoisted_78 = {
    for: "twoCorps-checkbox",
    title: "Always gain the Merger Prelude card (will be given post-draft)"
};
const _hoisted_79 = ["href"];
const _hoisted_80 = { for: "shuffleMap-checkbox" };
const _hoisted_81 = ["href"];
const _hoisted_82 = { for: "seeded-checkbox" };
const _hoisted_83 = ["href"];
const _hoisted_84 = { key: 5 };
const _hoisted_85 = { class: "create-game-subsection-label" };
const _hoisted_86 = { for: "customCorps-checkbox" };
const _hoisted_87 = { key: 0 };
const _hoisted_88 = { for: "customPreludes-checkbox" };
const _hoisted_89 = { key: 0 };
const _hoisted_90 = { for: "customCeos-checkbox" };
const _hoisted_91 = { key: 0 };
const _hoisted_92 = { for: "bannedCards-checkbox" };
const _hoisted_93 = { for: "includedCards-checkbox" };
const _hoisted_94 = { for: "customColonies-checkbox" };
const _hoisted_95 = { key: 0 };
const _hoisted_96 = { for: "removeNegativeEvent-checkbox" };
const _hoisted_97 = ["href"];
const _hoisted_98 = {
    key: 0,
    class: "create-game-page-column"
};
const _hoisted_99 = { class: "create-game-page-column-row" };
const _hoisted_100 = { for: "draft-checkbox" };
const _hoisted_101 = { for: "initialDraft-checkbox" };
const _hoisted_102 = ["href"];
const _hoisted_103 = {
    key: 0,
    class: "create-game-page-column-row"
};
const _hoisted_104 = { key: 0 };
const _hoisted_105 = { for: "preludeDraft-checkbox" };
const _hoisted_106 = { key: 1 };
const _hoisted_107 = { for: "ceosDraft-checkbox" };
const _hoisted_108 = { for: "randomFirstPlayer-checkbox" };
const _hoisted_109 = { for: "randomMA-checkbox" };
const _hoisted_110 = ["href"];
const _hoisted_111 = {
    key: 1,
    class: "create-game-page-column-row"
};
const _hoisted_112 = ["value"];
const _hoisted_113 = {
    class: "label-randomMAOption",
    for: "limitedRandomMA-radio"
};
const _hoisted_114 = ["value"];
const _hoisted_115 = {
    class: "label-randomMAOption",
    for: "unlimitedRandomMA-radio"
};
const _hoisted_116 = { for: "modularMA-checkbox" };
const _hoisted_117 = { key: 2 };
const _hoisted_118 = { for: "requiresVenusTrackCompletion-checkbox" };
const _hoisted_119 = ["href"];
const _hoisted_120 = { for: "fanMA-checkbox" };
const _hoisted_121 = { for: "realTimeVP-checkbox" };
const _hoisted_122 = ["href"];
const _hoisted_123 = { for: "fastMode-checkbox" };
const _hoisted_124 = ["href"];
const _hoisted_125 = { class: "create-game-players-cont" };
const _hoisted_126 = { class: "container" };
const _hoisted_127 = { class: "columns" };
const _hoisted_128 = ["placeholder", "onUpdate:modelValue"];
const _hoisted_129 = { class: "create-game-page-color-row" };
const _hoisted_130 = ["value", "name", "onUpdate:modelValue", "id"];
const _hoisted_131 = ["for"];
const _hoisted_132 = {
    key: 0,
    class: "form-switch form-inline create-game-beginner-option-label"
};
const _hoisted_133 = ["onUpdate:modelValue"];
const _hoisted_134 = ["href"];
const _hoisted_135 = { class: "form-label" };
const _hoisted_136 = ["onUpdate:modelValue"];
const _hoisted_137 = ["href"];
const _hoisted_138 = {
    key: 1,
    class: "form-radio form-inline"
};
const _hoisted_139 = ["value"];
const _hoisted_140 = { class: "create-game-action" };
const _hoisted_141 = {
    key: 5,
    class: "create-game--block"
};
const _hoisted_142 = {
    key: 6,
    class: "create-game--block"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _component_CorporationsFilter = (0, vue_1.resolveComponent)("CorporationsFilter");
    const _component_PreludesFilter = (0, vue_1.resolveComponent)("PreludesFilter");
    const _component_ColoniesFilter = (0, vue_1.resolveComponent)("ColoniesFilter");
    const _component_CeosFilter = (0, vue_1.resolveComponent)("CeosFilter");
    const _component_CardsFilter = (0, vue_1.resolveComponent)("CardsFilter");
    const _component_preferences_icon = (0, vue_1.resolveComponent)("preferences-icon");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("h1", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.constants.APP_NAME), 1)
            ])), [
                [_directive_i18n]
            ]),
            _cache[69] || (_cache[69] = (0, vue_1.createTextVNode)(" — ", -1)),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[68] || (_cache[68] = [
                    (0, vue_1.createTextVNode)("Create New Game", -1)
                ]))])), [
                [_directive_i18n]
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                href: _ctx.wikiUrls.changelog,
                class: "tooltip",
                "data-tooltip": "Link opens in a new tab/window",
                target: "_blank"
            }, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("u", null, [...(_cache[70] || (_cache[70] = [
                        (0, vue_1.createTextVNode)("Read our changelog to get the latest updates.", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ], 8, _hoisted_3)), [
                [_directive_i18n]
            ])
        ]),
        (_ctx.playersCount === 1)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                _cache[73] || (_cache[73] = (0, vue_1.createTextVNode)(" (", -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[71] || (_cache[71] = [
                        (0, vue_1.createTextVNode)("Looking for people to play with", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[74] || (_cache[74] = (0, vue_1.createTextVNode)("? ", -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                    href: _ctx.constants.DISCORD_INVITE,
                    class: "tooltip",
                    "data-tooltip": "Link opens in a new tab/window",
                    target: "_blank"
                }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("u", null, [...(_cache[72] || (_cache[72] = [
                            (0, vue_1.createTextVNode)("Join us on Discord", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ], 8, _hoisted_5)), [
                    [_directive_i18n]
                ]),
                _cache[75] || (_cache[75] = (0, vue_1.createTextVNode)(".) ", -1))
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_6, [
            (0, vue_1.createElementVNode)("div", _hoisted_7, [
                (0, vue_1.createElementVNode)("div", _hoisted_8, [
                    (0, vue_1.createElementVNode)("div", _hoisted_9, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h4", null, [...(_cache[76] || (_cache[76] = [
                                (0, vue_1.createTextVNode)("№ of Players", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)([1, 2, 3, 4, 5, 6], (pCount) => {
                            return (0, vue_1.createElementVNode)("div", { key: pCount }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "radio",
                                    value: pCount,
                                    name: "playersCount",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.playersCount) = $event)),
                                    id: pCount + '-radio'
                                }, null, 8, _hoisted_10), [
                                    [vue_1.vModelRadio, _ctx.playersCount]
                                ]),
                                (0, vue_1.createElementVNode)("label", {
                                    for: pCount + '-radio'
                                }, (0, vue_1.toDisplayString)(_ctx.getPlayersCountText(pCount)), 9, _hoisted_11)
                            ]);
                        }), 64))
                    ]),
                    (0, vue_1.createElementVNode)("div", _hoisted_12, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h4", null, [...(_cache[77] || (_cache[77] = [
                                (0, vue_1.createTextVNode)("Expansions", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "allOfficialExpansions",
                            id: "allOfficialExpansions-checkbox",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.allOfficialExpansions) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.allOfficialExpansions]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_13, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[78] || (_cache[78] = [
                                    (0, vue_1.createTextVNode)("All", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "corporateEra",
                            id: "corporateEra-checkbox",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.expansions.corpera) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.corpera]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_14, [
                            _cache[80] || (_cache[80] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-CE" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[79] || (_cache[79] = [
                                    (0, vue_1.createTextVNode)("Corporate Era", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "prelude",
                            id: "prelude-checkbox",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.expansions.prelude) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.prelude]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_15, [
                            _cache[82] || (_cache[82] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-prelude" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[81] || (_cache[81] = [
                                    (0, vue_1.createTextVNode)("Prelude", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "prelude2",
                            id: "prelude2-checkbox",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.expansions.prelude2) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.prelude2]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_16, [
                            _cache[84] || (_cache[84] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-prelude2" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[83] || (_cache[83] = [
                                    (0, vue_1.createTextVNode)("Prelude 2", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "venusNext",
                            id: "venusNext-checkbox",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.expansions.venus) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.venus]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_17, [
                            _cache[86] || (_cache[86] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-venus" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[85] || (_cache[85] = [
                                    (0, vue_1.createTextVNode)("Venus Next", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "colonies",
                            id: "colonies-checkbox",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.expansions.colonies) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.colonies]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_18, [
                            _cache[88] || (_cache[88] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-colony" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[87] || (_cache[87] = [
                                    (0, vue_1.createTextVNode)("Colonies", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "turmoil",
                            id: "turmoil-checkbox",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.expansions.turmoil) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.turmoil]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_19, [
                            _cache[90] || (_cache[90] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-turmoil" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[89] || (_cache[89] = [
                                    (0, vue_1.createTextVNode)("Turmoil", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "promo",
                            id: "promo-checkbox",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.expansions.promo) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.promo]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_20, [
                            _cache[93] || (_cache[93] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-promo" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[91] || (_cache[91] = [
                                    (0, vue_1.createTextVNode)("Promos", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[94] || (_cache[94] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.promo,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[92] || (_cache[92] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_21)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_22, [...(_cache[95] || (_cache[95] = [
                                (0, vue_1.createTextVNode)("Fan-made", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "ares",
                            id: "ares-checkbox",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.expansions.ares) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.ares]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_23, [
                            _cache[98] || (_cache[98] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-ares" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[96] || (_cache[96] = [
                                    (0, vue_1.createTextVNode)("Ares", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[99] || (_cache[99] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.ares,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[97] || (_cache[97] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_24)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.expansions.ares)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.aresExtremeVariant) = $event)),
                                    id: "aresExtremeVariantVariant-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.aresExtremeVariant]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_25, [
                                    _cache[102] || (_cache[102] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-ares" }, null, -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[100] || (_cache[100] = [
                                            (0, vue_1.createTextVNode)("Extreme", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[103] || (_cache[103] = (0, vue_1.createTextVNode)("  ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                        href: _ctx.wikiUrls.aresExtreme,
                                        class: "tooltip",
                                        "data-tooltip": "Link opens in a new tab/window",
                                        target: "_blank"
                                    }, [...(_cache[101] || (_cache[101] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))], 8, _hoisted_26)), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "community",
                            id: "communityCards-checkbox",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.expansions.community) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.community]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_27, [
                            _cache[106] || (_cache[106] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-community" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[104] || (_cache[104] = [
                                    (0, vue_1.createTextVNode)("Community", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[107] || (_cache[107] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.community,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[105] || (_cache[105] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_28)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "themoon",
                            id: "themoon-checkbox",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.expansions.moon) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.moon]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_29, [
                            _cache[110] || (_cache[110] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-themoon" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[108] || (_cache[108] = [
                                    (0, vue_1.createTextVNode)("The Moon", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[111] || (_cache[111] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.moon,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[109] || (_cache[109] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_30)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.expansions.moon)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.requiresMoonTrackCompletion) = $event)),
                                    id: "requiresMoonTrackCompletion-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.requiresMoonTrackCompletion]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_31, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[112] || (_cache[112] = [
                                            (0, vue_1.createTextVNode)("Mandatory Moon Terraforming", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                ]),
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.moonStandardProjectVariant) = $event)),
                                    id: "moonStandardProjectVariant2-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.moonStandardProjectVariant]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_32, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[113] || (_cache[113] = [
                                            (0, vue_1.createTextVNode)("Standard Project Variant #2", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[115] || (_cache[115] = (0, vue_1.createTextVNode)(" ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                        href: _ctx.wikiUrls.moonStandardProjectVariant,
                                        class: "tooltip",
                                        "data-tooltip": "Link opens in a new tab/window",
                                        target: "_blank"
                                    }, [...(_cache[114] || (_cache[114] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))], 8, _hoisted_33)), [
                                        [_directive_i18n]
                                    ])
                                ]),
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.moonStandardProjectVariant1) = $event)),
                                    id: "moonStandardProjectVariant1-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.moonStandardProjectVariant1]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_34, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[116] || (_cache[116] = [
                                            (0, vue_1.createTextVNode)("Standard Project Variant #1", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[118] || (_cache[118] = (0, vue_1.createTextVNode)(" ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                        href: _ctx.wikiUrls.moonStandardProjectVariant,
                                        class: "tooltip",
                                        "data-tooltip": "Link opens in a new tab/window",
                                        target: "_blank"
                                    }, [...(_cache[117] || (_cache[117] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))], 8, _hoisted_35)), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (_ctx.expansions.turmoil)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 2 }, [
                                (0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    name: "politicalAgendas",
                                    id: "politicalAgendas-checkbox",
                                    onChange: _cache[16] || (_cache[16] = ($event) => (_ctx.politicalAgendasExtensionToggle()))
                                }, null, 32),
                                (0, vue_1.createElementVNode)("label", _hoisted_36, [
                                    _cache[121] || (_cache[121] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-agendas" }, null, -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[119] || (_cache[119] = [
                                            (0, vue_1.createTextVNode)("Agendas", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[122] || (_cache[122] = (0, vue_1.createTextVNode)(" ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_37, [...(_cache[120] || (_cache[120] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                ]),
                                (_ctx.isPoliticalAgendasExtensionEnabled())
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_38, [
                                        (0, vue_1.createElementVNode)("div", null, [
                                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                type: "radio",
                                                name: "agendaStyle",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.politicalAgendasExtension) = $event)),
                                                value: _ctx.getPoliticalAgendasExtensionAgendaStyle('random'),
                                                id: "randomAgendaStyle-radio"
                                            }, null, 8, _hoisted_39), [
                                                [vue_1.vModelRadio, _ctx.politicalAgendasExtension]
                                            ]),
                                            (0, vue_1.createElementVNode)("label", _hoisted_40, [
                                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_41, [
                                                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getPoliticalAgendasExtensionAgendaStyle('random')), 1)
                                                ])), [
                                                    [_directive_i18n]
                                                ])
                                            ])
                                        ]),
                                        (0, vue_1.createElementVNode)("div", null, [
                                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                type: "radio",
                                                name: "agendaStyle",
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.politicalAgendasExtension) = $event)),
                                                value: _ctx.getPoliticalAgendasExtensionAgendaStyle('chairman'),
                                                id: "chairmanAgendaStyle-radio"
                                            }, null, 8, _hoisted_42), [
                                                [vue_1.vModelRadio, _ctx.politicalAgendasExtension]
                                            ]),
                                            (0, vue_1.createElementVNode)("label", _hoisted_43, [
                                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_44, [
                                                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getPoliticalAgendasExtensionAgendaStyle('chairman')), 1)
                                                ])), [
                                                    [_directive_i18n]
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : (0, vue_1.createCommentVNode)("", true)
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "pathfinders",
                            id: "pathfinders-checkbox",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.expansions.pathfinders) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.pathfinders]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_45, [
                            _cache[125] || (_cache[125] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-pathfinders" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[123] || (_cache[123] = [
                                    (0, vue_1.createTextVNode)("Pathfinders", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[126] || (_cache[126] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.pathfinders,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[124] || (_cache[124] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_46)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.expansions.venus)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 3 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.altVenusBoard) = $event)),
                                    id: "altVenusBoard-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.altVenusBoard]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_47, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[127] || (_cache[127] = [
                                            (0, vue_1.createTextVNode)("Alt. Venus Board", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[129] || (_cache[129] = (0, vue_1.createTextVNode)("  ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                        href: _ctx.wikiUrls.alternativeVenusBoard,
                                        class: "tooltip",
                                        "data-tooltip": "Link opens in a new tab/window",
                                        target: "_blank"
                                    }, [...(_cache[128] || (_cache[128] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))], 8, _hoisted_48)), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "ceo",
                            id: "ceo-checkbox",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.expansions.ceo) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.ceo]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_49, [
                            _cache[132] || (_cache[132] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-ceo" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[130] || (_cache[130] = [
                                    (0, vue_1.createTextVNode)("CEOs", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[133] || (_cache[133] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.ceo,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[131] || (_cache[131] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_50)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "starwars",
                            id: "starwars-checkbox",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.expansions.starwars) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.starwars]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_51, [
                            _cache[136] || (_cache[136] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-starwars" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[134] || (_cache[134] = [
                                    (0, vue_1.createTextVNode)("Star Wars", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[137] || (_cache[137] = (0, vue_1.createElementVNode)("span", null, null, -1)),
                            _cache[138] || (_cache[138] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.starwars,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[135] || (_cache[135] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_52)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "ceo",
                            id: "underworld-checkbox",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.expansions.underworld) = $event))
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.expansions.underworld]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_53, [
                            _cache[141] || (_cache[141] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-underworld" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[139] || (_cache[139] = [
                                    (0, vue_1.createTextVNode)("Underworld 2", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[142] || (_cache[142] = (0, vue_1.createElementVNode)("span", null, null, -1)),
                            _cache[143] || (_cache[143] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.underworld,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[140] || (_cache[140] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_54)), [
                                [_directive_i18n]
                            ])
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("div", _hoisted_55, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h4", null, [...(_cache[144] || (_cache[144] = [
                                (0, vue_1.createTextVNode)("Board", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.boards, (boardName) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: boardName }, [
                                (boardName === 'utopia planitia')
                                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_56, [...(_cache[145] || (_cache[145] = [
                                            (0, vue_1.createTextVNode)("Fan-made", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                    : (0, vue_1.createCommentVNode)("", true),
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "radio",
                                    value: boardName,
                                    name: "board",
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.board) = $event)),
                                    id: boardName + '-checkbox'
                                }, null, 8, _hoisted_57), [
                                    [vue_1.vModelRadio, _ctx.board]
                                ]),
                                (0, vue_1.createElementVNode)("label", {
                                    for: boardName + '-checkbox',
                                    class: "expansion-button"
                                }, [
                                    (0, vue_1.createElementVNode)("span", {
                                        class: (0, vue_1.normalizeClass)(_ctx.getBoardColorClass(boardName))
                                    }, "⬢", 2),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_59, [
                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(boardName), 1)
                                    ])), [
                                        [_directive_i18n]
                                    ]),
                                    (boardName !== _ctx.RandomBoardOption.OFFICIAL && boardName !== _ctx.RandomBoardOption.ALL)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                                            _cache[147] || (_cache[147] = (0, vue_1.createTextVNode)("  ", -1)),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                                href: _ctx.boardHref(boardName),
                                                class: "tooltip",
                                                "data-tooltip": "Link opens in a new tab/window",
                                                target: "_blank"
                                            }, [...(_cache[146] || (_cache[146] = [
                                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                                ]))], 8, _hoisted_60)), [
                                                [_directive_i18n]
                                            ])
                                        ], 64))
                                        : (0, vue_1.createCommentVNode)("", true)
                                ], 8, _hoisted_58)
                            ]));
                        }), 128))
                    ]),
                    (0, vue_1.createElementVNode)("div", _hoisted_61, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h4", null, [...(_cache[148] || (_cache[148] = [
                                (0, vue_1.createTextVNode)("Options", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_62, [
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "number",
                                class: "create-game-corporations-count",
                                value: "2",
                                min: "1",
                                max: 6,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.startingCorporations) = $event)),
                                id: "startingCorpNum-checkbox"
                            }, null, 512), [
                                [vue_1.vModelText, _ctx.startingCorporations]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[149] || (_cache[149] = [
                                    (0, vue_1.createTextVNode)("Starting Corporations", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.expansions.prelude)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_63, [
                                _cache[151] || (_cache[151] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-prelude" }, null, -1)),
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "number",
                                    class: "create-game-corporations-count",
                                    value: "4",
                                    min: "4",
                                    max: 8,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.startingPreludes) = $event)),
                                    id: "startingPreludeNum-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelText, _ctx.startingPreludes]
                                ]),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[150] || (_cache[150] = [
                                        (0, vue_1.createTextVNode)("Starting Preludes", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ]))
                            : (0, vue_1.createCommentVNode)("", true),
                        (_ctx.expansions.ceo)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_64, [
                                _cache[153] || (_cache[153] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-ceo" }, null, -1)),
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "number",
                                    class: "create-game-corporations-count",
                                    value: "3",
                                    min: "1",
                                    max: 6,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.startingCeos) = $event)),
                                    id: "startingCEONum-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelText, _ctx.startingCeos]
                                ]),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[152] || (_cache[152] = [
                                        (0, vue_1.createTextVNode)("Starting CEOs", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ]))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.solarPhaseOption) = $event)),
                            id: "WGT-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.solarPhaseOption]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_65, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[154] || (_cache[154] = [
                                    (0, vue_1.createTextVNode)("World Government Terraforming", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[156] || (_cache[156] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.worldGovernmentTerraforming,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[155] || (_cache[155] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_66)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.playersCount === 1)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 2 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.soloTR) = $event)),
                                    id: "soloTR-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.soloTR]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_67, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[157] || (_cache[157] = [
                                            (0, vue_1.createTextVNode)("63 TR solo mode", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[159] || (_cache[159] = (0, vue_1.createTextVNode)(" ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                        href: _ctx.wikiUrls.trSoloMode,
                                        class: "tooltip",
                                        "data-tooltip": "Link opens in a new tab/window",
                                        target: "_blank"
                                    }, [...(_cache[158] || (_cache[158] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))], 8, _hoisted_68)), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((_ctx.undoOption) = $event)),
                            id: "undo-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.undoOption]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_69, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[160] || (_cache[160] = [
                                    (0, vue_1.createTextVNode)("Allow undo", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[162] || (_cache[162] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.allowUndo,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[161] || (_cache[161] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_70)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.undoOption)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_71, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[163] || (_cache[163] = [
                                        (0, vue_1.createTextVNode)("Undo is now in best effort support.", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[165] || (_cache[165] = (0, vue_1.createElementVNode)("a", {
                                    href: "https://github.com/terraforming-mars/terraforming-mars/discussions/7647",
                                    target: "_blank"
                                }, "ⓘ", -1)),
                                _cache[166] || (_cache[166] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[164] || (_cache[164] = [
                                        (0, vue_1.createTextVNode)("No effort will be spent to fix it.", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ]))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((_ctx.showTimers) = $event)),
                            id: "timer-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.showTimers]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_72, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[167] || (_cache[167] = [
                                    (0, vue_1.createTextVNode)("Show timers", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((_ctx.escapeVelocityMode) = $event)),
                            id: "escapevelocity-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.escapeVelocityMode]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_73, [
                            _cache[170] || (_cache[170] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-escape-velocity" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[168] || (_cache[168] = [
                                    (0, vue_1.createTextVNode)("Escape Velocity", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[171] || (_cache[171] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.escapeVelocity,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[169] || (_cache[169] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_74)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("label", _hoisted_75, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[172] || (_cache[172] = [
                                    (0, vue_1.createTextVNode)("After", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[174] || (_cache[174] = (0, vue_1.createElementVNode)("span", null, " ", -1)),
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "number",
                                class: "create-game-corporations-count",
                                value: "30",
                                step: "5",
                                min: "0",
                                max: 180,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((_ctx.escapeVelocityThreshold) = $event)),
                                id: "escapeThreshold-checkbox"
                            }, null, 512), [
                                [vue_1.vModelText, _ctx.escapeVelocityThreshold]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[173] || (_cache[173] = [
                                    (0, vue_1.createTextVNode)("min", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ], 512), [
                            [vue_1.vShow, _ctx.escapeVelocityMode]
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("label", _hoisted_76, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[175] || (_cache[175] = [
                                    (0, vue_1.createTextVNode)("Plus", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[177] || (_cache[177] = (0, vue_1.createElementVNode)("span", null, " ", -1)),
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "number",
                                class: "create-game-corporations-count",
                                value: "2",
                                step: "1",
                                min: "1",
                                max: 10,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((_ctx.escapeVelocityBonusSeconds) = $event)),
                                id: "escapeBonusSeconds-checkbox"
                            }, null, 512), [
                                [vue_1.vModelText, _ctx.escapeVelocityBonusSeconds]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[176] || (_cache[176] = [
                                    (0, vue_1.createTextVNode)("seconds per action", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ], 512), [
                            [vue_1.vShow, _ctx.escapeVelocityMode]
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("label", _hoisted_77, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[178] || (_cache[178] = [
                                    (0, vue_1.createTextVNode)("Reduce", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[181] || (_cache[181] = (0, vue_1.createElementVNode)("span", null, " ", -1)),
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "number",
                                class: "create-game-corporations-count",
                                value: "1",
                                min: "1",
                                max: 10,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((_ctx.escapeVelocityPenalty) = $event)),
                                id: "escapePeriod-checkbox"
                            }, null, 512), [
                                [vue_1.vModelText, _ctx.escapeVelocityPenalty]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[179] || (_cache[179] = [
                                    (0, vue_1.createTextVNode)("VP every", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[182] || (_cache[182] = (0, vue_1.createElementVNode)("span", null, " ", -1)),
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "number",
                                class: "create-game-corporations-count",
                                value: "2",
                                min: "1",
                                max: 10,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((_ctx.escapeVelocityPeriod) = $event)),
                                id: "escapePeriod-checkbox"
                            }, null, 512), [
                                [vue_1.vModelText, _ctx.escapeVelocityPeriod]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[180] || (_cache[180] = [
                                    (0, vue_1.createTextVNode)("min", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ], 512), [
                            [vue_1.vShow, _ctx.escapeVelocityMode]
                        ]),
                        (_ctx.expansions.prelude)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 4 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((_ctx.twoCorpsVariant) = $event)),
                                    id: "twoCorps-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.twoCorpsVariant]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_78, [
                                    _cache[185] || (_cache[185] = (0, vue_1.createElementVNode)("div", { class: "create-game-expansion-icon expansion-icon-prelude" }, null, -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[183] || (_cache[183] = [
                                            (0, vue_1.createTextVNode)("Merger", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[186] || (_cache[186] = (0, vue_1.createTextVNode)(" ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                        href: _ctx.wikiUrls.merger,
                                        class: "tooltip",
                                        "data-tooltip": "Link opens in a new tab/window",
                                        target: "_blank"
                                    }, [...(_cache[184] || (_cache[184] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))], 8, _hoisted_79)), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((_ctx.shuffleMapOption) = $event)),
                            id: "shuffleMap-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.shuffleMapOption]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_80, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[187] || (_cache[187] = [
                                    (0, vue_1.createTextVNode)("Randomize board tiles", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[189] || (_cache[189] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.randomizeBoardTiles,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[188] || (_cache[188] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_81)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((_ctx.seededGame) = $event)),
                            id: "seeded-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.seededGame]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_82, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[190] || (_cache[190] = [
                                    (0, vue_1.createTextVNode)("Set Predefined Game", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[192] || (_cache[192] = (0, vue_1.createTextVNode)(" ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: _ctx.wikiUrls.setPredefinedGame,
                                class: "tooltip",
                                "data-tooltip": "Link opens in a new tab/window",
                                target: "_blank"
                            }, [...(_cache[191] || (_cache[191] = [
                                    (0, vue_1.createTextVNode)("ⓘ", -1)
                                ]))], 8, _hoisted_83)), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.seededGame)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_84, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "text",
                                    name: "clonedGamedId",
                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((_ctx.clonedGameId) = $event))
                                }, null, 512), [
                                    [vue_1.vModelText, _ctx.clonedGameId]
                                ])
                            ]))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_85, [...(_cache[193] || (_cache[193] = [
                                (0, vue_1.createTextVNode)("Filter", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((_ctx.showCorporationList) = $event)),
                            id: "customCorps-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.showCorporationList]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_86, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[194] || (_cache[194] = [
                                    (0, vue_1.createTextVNode)("Custom Corporation list", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (_ctx.customCorporations.length)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_87, " (" + (0, vue_1.toDisplayString)(_ctx.customCorporations.length) + ")", 1))
                                : (0, vue_1.createCommentVNode)("", true)
                        ]),
                        (_ctx.expansions.prelude)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 6 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => ((_ctx.showPreludesList) = $event)),
                                    id: "customPreludes-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.showPreludesList]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_88, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[195] || (_cache[195] = [
                                            (0, vue_1.createTextVNode)("Custom Preludes list", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (_ctx.customPreludes.length)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_89, " (" + (0, vue_1.toDisplayString)(_ctx.customPreludes.length) + ")", 1))
                                        : (0, vue_1.createCommentVNode)("", true)
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (_ctx.expansions.ceo)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 7 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((_ctx.showCeosList) = $event)),
                                    id: "customCeos-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.showCeosList]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_90, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[196] || (_cache[196] = [
                                            (0, vue_1.createTextVNode)("Custom CEOs list", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (_ctx.customCeos.length)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_91, " (" + (0, vue_1.toDisplayString)(_ctx.customCeos.length) + ")", 1))
                                        : (0, vue_1.createCommentVNode)("", true)
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => ((_ctx.showBannedCards) = $event)),
                            id: "bannedCards-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.showBannedCards]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_92, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[197] || (_cache[197] = [
                                    (0, vue_1.createTextVNode)("Exclude some cards", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((_ctx.showIncludedCards) = $event)),
                            id: "includedCards-checkbox"
                        }, null, 512), [
                            [vue_1.vModelCheckbox, _ctx.showIncludedCards]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_93, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[198] || (_cache[198] = [
                                    (0, vue_1.createTextVNode)("Include some cards", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.expansions.colonies)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 8 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => ((_ctx.showColoniesList) = $event)),
                                    id: "customColonies-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.showColoniesList]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_94, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[199] || (_cache[199] = [
                                            (0, vue_1.createTextVNode)("Custom Colonies list", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (_ctx.customColonies.length)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_95, " (" + (0, vue_1.toDisplayString)(_ctx.customColonies.length) + ")", 1))
                                        : (0, vue_1.createCommentVNode)("", true)
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true),
                        (_ctx.expansions.turmoil)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 9 }, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => ((_ctx.removeNegativeGlobalEventsOption) = $event)),
                                    id: "removeNegativeEvent-checkbox"
                                }, null, 512), [
                                    [vue_1.vModelCheckbox, _ctx.removeNegativeGlobalEventsOption]
                                ]),
                                (0, vue_1.createElementVNode)("label", _hoisted_96, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[200] || (_cache[200] = [
                                            (0, vue_1.createTextVNode)("Remove negative Global Events", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[202] || (_cache[202] = (0, vue_1.createTextVNode)(" ", -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                        href: _ctx.wikiUrls.removeNegativeGlobalEvents,
                                        class: "tooltip",
                                        "data-tooltip": "Link opens in a new tab/window",
                                        target: "_blank"
                                    }, [...(_cache[201] || (_cache[201] = [
                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                        ]))], 8, _hoisted_97)), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ], 64))
                            : (0, vue_1.createCommentVNode)("", true)
                    ]),
                    (_ctx.playersCount > 1)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_98, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h4", null, [...(_cache[203] || (_cache[203] = [
                                    (0, vue_1.createTextVNode)("Multiplayer Options", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_1.createElementVNode)("div", _hoisted_99, [
                                (0, vue_1.createElementVNode)("div", null, [
                                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                        type: "checkbox",
                                        name: "draftVariant",
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((_ctx.draftVariant) = $event)),
                                        id: "draft-checkbox"
                                    }, null, 512), [
                                        [vue_1.vModelCheckbox, _ctx.draftVariant]
                                    ]),
                                    (0, vue_1.createElementVNode)("label", _hoisted_100, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[204] || (_cache[204] = [
                                                (0, vue_1.createTextVNode)("Draft variant", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ])
                                    ])
                                ]),
                                (0, vue_1.createElementVNode)("div", null, [
                                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                        type: "checkbox",
                                        name: "initialDraft",
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event) => ((_ctx.initialDraft) = $event)),
                                        id: "initialDraft-checkbox"
                                    }, null, 512), [
                                        [vue_1.vModelCheckbox, _ctx.initialDraft]
                                    ]),
                                    (0, vue_1.createElementVNode)("label", _hoisted_101, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[205] || (_cache[205] = [
                                                (0, vue_1.createTextVNode)("Initial Draft variant", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ]),
                                        _cache[207] || (_cache[207] = (0, vue_1.createTextVNode)(" ", -1)),
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                            href: _ctx.wikiUrls.initialDraft,
                                            class: "tooltip",
                                            "data-tooltip": "Link opens in a new tab/window",
                                            target: "_blank"
                                        }, [...(_cache[206] || (_cache[206] = [
                                                (0, vue_1.createTextVNode)("ⓘ", -1)
                                            ]))], 8, _hoisted_102)), [
                                            [_directive_i18n]
                                        ])
                                    ])
                                ])
                            ]),
                            (_ctx.initialDraft)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_103, [
                                    (_ctx.expansions.prelude)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_104, [
                                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                type: "checkbox",
                                                name: "preludeDraft",
                                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => ((_ctx.preludeDraftVariant) = $event)),
                                                id: "preludeDraft-checkbox"
                                            }, null, 512), [
                                                [vue_1.vModelCheckbox, _ctx.preludeDraftVariant]
                                            ]),
                                            (0, vue_1.createElementVNode)("label", _hoisted_105, [
                                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[208] || (_cache[208] = [
                                                        (0, vue_1.createTextVNode)("Prelude Draft", -1)
                                                    ]))])), [
                                                    [_directive_i18n]
                                                ])
                                            ])
                                        ]))
                                        : (0, vue_1.createCommentVNode)("", true),
                                    (_ctx.expansions.ceo)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_106, [
                                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                type: "checkbox",
                                                name: "ceosDraft",
                                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event) => ((_ctx.ceosDraftVariant) = $event)),
                                                id: "ceosDraft-checkbox"
                                            }, null, 512), [
                                                [vue_1.vModelCheckbox, _ctx.ceosDraftVariant]
                                            ]),
                                            (0, vue_1.createElementVNode)("label", _hoisted_107, [
                                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[209] || (_cache[209] = [
                                                        (0, vue_1.createTextVNode)("CEO Draft", -1)
                                                    ]))])), [
                                                    [_directive_i18n]
                                                ])
                                            ])
                                        ]))
                                        : (0, vue_1.createCommentVNode)("", true)
                                ]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event) => ((_ctx.randomFirstPlayer) = $event)),
                                id: "randomFirstPlayer-checkbox"
                            }, null, 512), [
                                [vue_1.vModelCheckbox, _ctx.randomFirstPlayer]
                            ]),
                            (0, vue_1.createElementVNode)("label", _hoisted_108, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[210] || (_cache[210] = [
                                        (0, vue_1.createTextVNode)("Random first player", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ]),
                            (0, vue_1.createElementVNode)("input", {
                                type: "checkbox",
                                name: "randomMAToggle",
                                id: "randomMA-checkbox",
                                onChange: _cache[53] || (_cache[53] = ($event) => (_ctx.randomMAToggle()))
                            }, null, 32),
                            (0, vue_1.createElementVNode)("label", _hoisted_109, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[211] || (_cache[211] = [
                                        (0, vue_1.createTextVNode)("Random Milestones/Awards", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[213] || (_cache[213] = (0, vue_1.createTextVNode)(" ", -1)),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                    href: _ctx.wikiUrls.randomMilestonesAndAwards,
                                    class: "tooltip",
                                    "data-tooltip": "Link opens in a new tab/window",
                                    target: "_blank"
                                }, [...(_cache[212] || (_cache[212] = [
                                        (0, vue_1.createTextVNode)("ⓘ", -1)
                                    ]))], 8, _hoisted_110)), [
                                    [_directive_i18n]
                                ])
                            ]),
                            (_ctx.isRandomMAEnabled())
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_111, [
                                    (0, vue_1.createElementVNode)("div", null, [
                                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                            type: "radio",
                                            name: "randomMAOption",
                                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event) => ((_ctx.randomMA) = $event)),
                                            value: _ctx.getRandomMaOptionType('limited'),
                                            id: "limitedRandomMA-radio"
                                        }, null, 8, _hoisted_112), [
                                            [vue_1.vModelRadio, _ctx.randomMA]
                                        ]),
                                        (0, vue_1.createElementVNode)("label", _hoisted_113, [
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getRandomMaOptionType('limited')), 1)
                                            ])), [
                                                [_directive_i18n]
                                            ])
                                        ])
                                    ]),
                                    (0, vue_1.createElementVNode)("div", null, [
                                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                            type: "radio",
                                            name: "randomMAOption",
                                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event) => ((_ctx.randomMA) = $event)),
                                            value: _ctx.getRandomMaOptionType('full'),
                                            id: "unlimitedRandomMA-radio"
                                        }, null, 8, _hoisted_114), [
                                            [vue_1.vModelRadio, _ctx.randomMA]
                                        ]),
                                        (0, vue_1.createElementVNode)("label", _hoisted_115, [
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getRandomMaOptionType('full')), 1)
                                            ])), [
                                                [_directive_i18n]
                                            ])
                                        ])
                                    ]),
                                    (0, vue_1.createElementVNode)("div", null, [
                                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                            type: "checkbox",
                                            name: "modularMA",
                                            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event) => ((_ctx.modularMA) = $event)),
                                            id: "modularMA-checkbox"
                                        }, null, 512), [
                                            [vue_1.vModelCheckbox, _ctx.modularMA]
                                        ]),
                                        (0, vue_1.createElementVNode)("label", _hoisted_116, [
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[214] || (_cache[214] = [
                                                    (0, vue_1.createTextVNode)("Official Random α", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ])
                                        ])
                                    ])
                                ]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.modularMA)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_117, [...(_cache[215] || (_cache[215] = [
                                        (0, vue_1.createTextVNode)(" The new Milestones and Awards are still in active development.", -1),
                                        (0, vue_1.createElementVNode)("br", null, null, -1),
                                        (0, vue_1.createTextVNode)(" Please don't report anything unless it breaks the game.", -1),
                                        (0, vue_1.createElementVNode)("br", null, null, -1),
                                        (0, vue_1.createTextVNode)(" These are ", -1),
                                        (0, vue_1.createElementVNode)("b", null, "always fully random", -1),
                                        (0, vue_1.createTextVNode)(". ", -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.expansions.venus)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 3 }, [
                                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event) => ((_ctx.requiresVenusTrackCompletion) = $event)),
                                        id: "requiresVenusTrackCompletion-checkbox"
                                    }, null, 512), [
                                        [vue_1.vModelCheckbox, _ctx.requiresVenusTrackCompletion]
                                    ]),
                                    (0, vue_1.createElementVNode)("label", _hoisted_118, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[216] || (_cache[216] = [
                                                (0, vue_1.createTextVNode)("Mandatory Venus Terraforming", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ]),
                                        _cache[218] || (_cache[218] = (0, vue_1.createTextVNode)("  ", -1)),
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                            href: _ctx.wikiUrls.venusTerraforming,
                                            class: "tooltip",
                                            "data-tooltip": "Link opens in a new tab/window",
                                            target: "_blank"
                                        }, [...(_cache[217] || (_cache[217] = [
                                                (0, vue_1.createTextVNode)("ⓘ", -1)
                                            ]))], 8, _hoisted_119)), [
                                            [_directive_i18n]
                                        ])
                                    ])
                                ], 64))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.randomMA !== _ctx.RandomMAOptionType.NONE)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 4 }, [
                                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event) => ((_ctx.includeFanMA) = $event)),
                                        id: "fanMA-checkbox"
                                    }, null, 512), [
                                        [vue_1.vModelCheckbox, _ctx.includeFanMA]
                                    ]),
                                    (0, vue_1.createElementVNode)("label", _hoisted_120, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[219] || (_cache[219] = [
                                                (0, vue_1.createTextVNode)("Include fan Milestones/Awards", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ])
                                    ])
                                ], 64))
                                : (0, vue_1.createCommentVNode)("", true),
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "checkbox",
                                name: "showOtherPlayersVP",
                                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event) => ((_ctx.showOtherPlayersVP) = $event)),
                                id: "realTimeVP-checkbox"
                            }, null, 512), [
                                [vue_1.vModelCheckbox, _ctx.showOtherPlayersVP]
                            ]),
                            (0, vue_1.createElementVNode)("label", _hoisted_121, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[220] || (_cache[220] = [
                                        (0, vue_1.createTextVNode)("Show real-time VP", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[222] || (_cache[222] = (0, vue_1.createTextVNode)(" ", -1)),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                    href: _ctx.wikiUrls.showRealtimeVP,
                                    class: "tooltip",
                                    "data-tooltip": "Link opens in a new tab/window",
                                    target: "_blank"
                                }, [...(_cache[221] || (_cache[221] = [
                                        (0, vue_1.createTextVNode)("ⓘ", -1)
                                    ]))], 8, _hoisted_122)), [
                                    [_directive_i18n]
                                ])
                            ]),
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event) => ((_ctx.fastModeOption) = $event)),
                                id: "fastMode-checkbox"
                            }, null, 512), [
                                [vue_1.vModelCheckbox, _ctx.fastModeOption]
                            ]),
                            (0, vue_1.createElementVNode)("label", _hoisted_123, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[223] || (_cache[223] = [
                                        (0, vue_1.createTextVNode)("Fast mode", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[225] || (_cache[225] = (0, vue_1.createTextVNode)(" ", -1)),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                    href: _ctx.wikiUrls.fastMode,
                                    class: "tooltip",
                                    "data-tooltip": "Link opens in a new tab/window",
                                    target: "_blank"
                                }, [...(_cache[224] || (_cache[224] = [
                                        (0, vue_1.createTextVNode)("ⓘ", -1)
                                    ]))], 8, _hoisted_124)), [
                                    [_directive_i18n]
                                ])
                            ])
                        ]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (0, vue_1.createElementVNode)("div", _hoisted_125, [
                        (0, vue_1.createElementVNode)("div", _hoisted_126, [
                            (0, vue_1.createElementVNode)("div", _hoisted_127, [
                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getPlayers(), (newPlayer, index) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: index }, [
                                        (0, vue_1.createElementVNode)("div", {
                                            class: (0, vue_1.normalizeClass)('form-group col6 create-game-player ' + _ctx.getPlayerContainerColorClass(newPlayer.color))
                                        }, [
                                            (0, vue_1.createElementVNode)("div", null, [
                                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                    class: "form-input form-inline create-game-player-name",
                                                    placeholder: _ctx.getPlayerNamePlaceholder(index),
                                                    "onUpdate:modelValue": ($event) => ((newPlayer.name) = $event)
                                                }, null, 8, _hoisted_128), [
                                                    [vue_1.vModelText, newPlayer.name]
                                                ])
                                            ]),
                                            (0, vue_1.createElementVNode)("div", _hoisted_129, [
                                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.PLAYER_COLORS, (color) => {
                                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: color }, [
                                                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                            type: "radio",
                                                            value: color,
                                                            name: 'playerColor' + (index + 1),
                                                            "onUpdate:modelValue": ($event) => ((newPlayer.color) = $event),
                                                            id: 'radioBox' + color + (index + 1)
                                                        }, null, 8, _hoisted_130), [
                                                            [vue_1.vModelRadio, newPlayer.color]
                                                        ]),
                                                        (0, vue_1.createElementVNode)("label", {
                                                            for: 'radioBox' + color + (index + 1)
                                                        }, [
                                                            (0, vue_1.createElementVNode)("div", {
                                                                class: (0, vue_1.normalizeClass)('create-game-colorbox ' + _ctx.getPlayerCubeColorClass(color))
                                                            }, null, 2)
                                                        ], 8, _hoisted_131)
                                                    ]));
                                                }), 128))
                                            ]),
                                            (0, vue_1.createElementVNode)("div", null, [
                                                (_ctx.isBeginnerToggleEnabled())
                                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_132, [
                                                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": ($event) => ((newPlayer.beginner) = $event)
                                                        }, null, 8, _hoisted_133), [
                                                            [vue_1.vModelCheckbox, newPlayer.beginner]
                                                        ]),
                                                        _cache[228] || (_cache[228] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                                                        _cache[229] || (_cache[229] = (0, vue_1.createTextVNode)()),
                                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[226] || (_cache[226] = [
                                                                (0, vue_1.createTextVNode)("Beginner?", -1)
                                                            ]))])), [
                                                            [_directive_i18n]
                                                        ]),
                                                        _cache[230] || (_cache[230] = (0, vue_1.createTextVNode)(" ", -1)),
                                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                                            href: _ctx.wikiUrls.beginnerCorporation,
                                                            class: "tooltip",
                                                            "data-tooltip": "Link opens in a new tab/window",
                                                            target: "_blank"
                                                        }, [...(_cache[227] || (_cache[227] = [
                                                                (0, vue_1.createTextVNode)("ⓘ", -1)
                                                            ]))], 8, _hoisted_134)), [
                                                            [_directive_i18n]
                                                        ])
                                                    ]))
                                                    : (0, vue_1.createCommentVNode)("", true),
                                                (0, vue_1.createElementVNode)("label", _hoisted_135, [
                                                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                        type: "number",
                                                        class: "form-input form-inline player-handicap",
                                                        value: "0",
                                                        min: "0",
                                                        max: 10,
                                                        "onUpdate:modelValue": ($event) => ((newPlayer.handicap) = $event)
                                                    }, null, 8, _hoisted_136), [
                                                        [
                                                            vue_1.vModelText,
                                                            newPlayer.handicap,
                                                            void 0,
                                                            { number: true }
                                                        ]
                                                    ]),
                                                    _cache[233] || (_cache[233] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[231] || (_cache[231] = [
                                                            (0, vue_1.createTextVNode)("TR Boost", -1)
                                                        ]))])), [
                                                        [_directive_i18n]
                                                    ]),
                                                    _cache[234] || (_cache[234] = (0, vue_1.createTextVNode)(" ", -1)),
                                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                                        href: _ctx.wikiUrls.trBoost,
                                                        class: "tooltip",
                                                        "data-tooltip": "Link opens in a new tab/window",
                                                        target: "_blank"
                                                    }, [...(_cache[232] || (_cache[232] = [
                                                            (0, vue_1.createTextVNode)("ⓘ", -1)
                                                        ]))], 8, _hoisted_137)), [
                                                        [_directive_i18n]
                                                    ])
                                                ]),
                                                (!_ctx.randomFirstPlayer)
                                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_138, [
                                                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                            type: "radio",
                                                            name: "firstIndex",
                                                            value: index + 1,
                                                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event) => ((_ctx.firstIndex) = $event))
                                                        }, null, 8, _hoisted_139), [
                                                            [vue_1.vModelRadio, _ctx.firstIndex]
                                                        ]),
                                                        _cache[236] || (_cache[236] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                                                        _cache[237] || (_cache[237] = (0, vue_1.createTextVNode)()),
                                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[235] || (_cache[235] = [
                                                                (0, vue_1.createTextVNode)("Goes First?", -1)
                                                            ]))])), [
                                                            [_directive_i18n]
                                                        ])
                                                    ]))
                                                    : (0, vue_1.createCommentVNode)("", true)
                                            ])
                                        ], 2)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("div", _hoisted_140, [
                        (0, vue_1.createVNode)(_component_AppButton, {
                            title: "Create game",
                            size: "big",
                            onClick: _ctx.createGame
                        }, null, 8, ["onClick"]),
                        (0, vue_1.createElementVNode)("label", null, [
                            _cache[238] || (_cache[238] = (0, vue_1.createElementVNode)("div", { class: "btn btn-primary btn-action btn-lg" }, [
                                (0, vue_1.createElementVNode)("i", { class: "icon icon-upload" })
                            ], -1)),
                            (0, vue_1.createElementVNode)("input", {
                                style: { "display": "none" },
                                type: "file",
                                accept: ".json",
                                id: "settings-file",
                                ref: "file",
                                onChange: _cache[62] || (_cache[62] = ($event) => (_ctx.uploadSettings()))
                            }, null, 544)
                        ]),
                        (0, vue_1.createElementVNode)("label", null, [
                            (0, vue_1.createElementVNode)("div", {
                                onClick: _cache[63] || (_cache[63] = ($event) => (_ctx.downloadSettings())),
                                class: "btn btn-primary btn-action btn-lg"
                            }, [...(_cache[239] || (_cache[239] = [
                                    (0, vue_1.createElementVNode)("i", { class: "icon icon-download" }, null, -1)
                                ]))])
                        ])
                    ])
                ])
            ])
        ]),
        (_ctx.showCorporationList)
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CorporationsFilter, {
                key: 1,
                ref: "corporationsFilter",
                onCorporationListChanged: _ctx.updateCustomCorporations,
                expansions: _ctx.expansions,
                selected: _ctx.customCorporations,
                onClose: _cache[64] || (_cache[64] = ($event) => (_ctx.showCorporationList = false))
            }, null, 8, ["onCorporationListChanged", "expansions", "selected"])), [
                [vue_1.vShow, _ctx.showCorporationList]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showPreludesList)
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_PreludesFilter, {
                key: 2,
                ref: "preludesFilter",
                onPreludeListChanged: _ctx.updateCustomPreludes,
                expansions: _ctx.expansions,
                selected: _ctx.customPreludes,
                onClose: _cache[65] || (_cache[65] = ($event) => (_ctx.showPreludesList = false))
            }, null, 8, ["onPreludeListChanged", "expansions", "selected"])), [
                [vue_1.vShow, _ctx.showPreludesList]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showColoniesList)
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_ColoniesFilter, {
                key: 3,
                ref: "coloniesFilter",
                onColoniesListChanged: _ctx.updateCustomColonies,
                expansions: _ctx.expansions,
                selected: _ctx.customColonies,
                onClose: _cache[66] || (_cache[66] = ($event) => (_ctx.showColoniesList = false))
            }, null, 8, ["onColoniesListChanged", "expansions", "selected"])), [
                [vue_1.vShow, _ctx.showColoniesList]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showCeosList)
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CeosFilter, {
                key: 4,
                ref: "ceosFilter",
                onCeoListChanged: _ctx.updateCustomCeos,
                expansions: _ctx.expansions,
                selected: _ctx.customCeos,
                onClose: _cache[67] || (_cache[67] = ($event) => (_ctx.showCeosList = false))
            }, null, 8, ["onCeoListChanged", "expansions", "selected"])), [
                [vue_1.vShow, _ctx.showCeosList]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showBannedCards)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_141, [
                (0, vue_1.createVNode)(_component_CardsFilter, {
                    ref: "cardsFilter",
                    onCardsListChanged: _ctx.updateBannedCards,
                    title: 'Cards to exclude from the game',
                    hint: 'Start typing the card name to exclude'
                }, null, 8, ["onCardsListChanged"])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showIncludedCards)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_142, [
                (0, vue_1.createVNode)(_component_CardsFilter, {
                    ref: "cardsFilter2",
                    onCardsListChanged: _ctx.updateIncludedCards,
                    title: 'Cards to include in the game',
                    hint: 'Start typing the card name to include'
                }, null, 8, ["onCardsListChanged"])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_preferences_icon)
    ]));
}
